import { render } from "./NsiExportPotentialServiceTypeCard.vue?vue&type=template&id=19319323"
import script from "./NsiExportPotentialServiceTypeCard.vue?vue&type=script&lang=js"
export * from "./NsiExportPotentialServiceTypeCard.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__